import type { DayInfo } from './types';

export function formatDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getDays(start: Date, end: Date): DayInfo[] {
  const days: DayInfo[] = [];
  const c = new Date(start);
  while (c <= end) {
    days.push({ date: new Date(c), str: formatDate(c) });
    c.setDate(c.getDate() + 1);
  }
  return days;
}

export function formatPublishDate(dateStr: string, monthsShort: string[]): string {
  const d = new Date(dateStr + 'T00:00:00');
  return `${d.getDate()} ${monthsShort[d.getMonth()]} ${d.getFullYear()}`;
}
